import {NotixApi} from "Services/api";
import UserService from "./user";

class NotixLogger {
    logError(body) {
        //Need fix set correct env on production
        /*if (config.env === DEVELOPMENT) {
          console.log("Logging stub:", body);
          return true;
        }*/

        if (UserService.isAuthenticated()) {
            NotixApi.post("/errors/log", body);
            return true;
        }
    }
}

const notixLoggerInstance = new NotixLogger();

export default notixLoggerInstance;